import React from 'react';
import { SVGS } from '../../assets';
import './delete-message.scss';
import { CommonButton } from '../button';
export const DeleteMessage = () => {
  return (
    <div className="delete-message-container">
      <img src={SVGS.TrashIcon} alt="" />
      <div className="delete-message-container-body">
        <div className="delete-message-container-body-title font-semibold">
          Delete Message?
        </div>
        <div className="delete-message-container-body-subtitle font-regular">
          Are you sure you want to delete the message?
        </div>
      </div>
      <div className="delete-message-container-footer">
        <CommonButton
          onPress={() => {}}
          text={'Cancel'}
          buttonStyle="delete-message-container-footer-cancel-btn"
        />
        <CommonButton
          onPress={() => {}}
          text={'Delete'}
          buttonStyle="delete-message-container-footer-delete-btn"
        />
      </div>
    </div>
  );
};
